import { render } from "./OkayaReturn.vue?vue&type=template&id=27dad50c&scoped=true"
import script from "./OkayaReturn.vue?vue&type=script&lang=js"
export * from "./OkayaReturn.vue?vue&type=script&lang=js"

import "./OkayaReturn.vue?vue&type=style&index=0&id=27dad50c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dad50c"]])

export default __exports__